import React from 'react';
import AlertsManagement from '../components/AlertsManagement';

const AlertsPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-8 transition-colors duration-300 ease-in-out">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">Alarm Merkezi</h1>
                <p className="text-gray-600 dark:text-gray-400 mb-8">
                    Takip ettiğiniz varlıklar için fiyat hedefleri belirleyin, hedefe ulaşıldığında email ile anında haberdar olun.
                </p>
                <AlertsManagement />
            </div>
        </div>
    );
};

export default AlertsPage;
